import * as Sentry from "@sentry/react";

import {
  useCoveragePriceCalculations,
  useFormState,
} from "Store/priceCalculation/priceCalculationHooks";

import { WrapLgMarginBottom } from "App/global-style";
import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { ProductPriceTile } from "Components/Features/CheckPrice/Tiles/ProductPriceTile";
import { DittoCoverageCard } from "Components/Features/CheckPrice/Tiles/ProductPriceTile/Coverages/DittoCoverages/DittoCoverageCard";
import { BackendErrorAlert } from "Components/Form/CommonFormElements/BackendErrorAlert/BackendErrorAlert";
import { InputFailureTracker } from "Components/InputFailureTracker";
import { NavigationButtons } from "Components/NavigationButtons";
import { getCollectionOfDittoComponents } from "Components/TextContext";
import { TextComponentNameLevel1 } from "Components/TextContext/textConstants";
import { useAddProductToCartHandler } from "Store/addProductToCart/hooks";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { RentalCoverage } from "Store/interfaces/products/coverage";
import { ReduxState } from "Store/rootReducer";
import { Form } from "formik";
import React from "react";
import { useSelector } from "react-redux";
import { RENTAL_PRICE_STEP } from "..";
import { RentalProductPriceFormValues } from "../rentalFormValuesInterfaces";
import { validationSchema } from "./rentalProductPriceValidation";

export const RentalProductPrice = (): React.ReactElement => {
  const handleAddProductToCart = useAddProductToCartHandler(
    RENTAL_PRICE_STEP.id,
  );
  const { priceCalculation, addProductToCart } = useSelector(
    (state: ReduxState) => state,
  );

  const { rental: productCardTexts } = getCollectionOfDittoComponents(
    TextComponentNameLevel1.COVERAGE_CARD,
  );

  const [coverage] = useCoveragePriceCalculations();
  const initialFormState = useFormState(RENTAL_PRICE_STEP.id, {
    coverage: RentalCoverage.RENTAL,
  }) as RentalProductPriceFormValues;

  const handleSubmit = (formProps: RentalProductPriceFormValues): void => {
    const productToAdd = {
      coverage: formProps.coverage,
      productType: INSURANCE_NAME_VALUE.RENTAL,
    };
    handleAddProductToCart(formProps, [productToAdd]);
  };
  return (
    <Sentry.ErrorBoundary
      beforeCapture={(scope) => {
        scope.setTag(
          "location",
          `CheckPrice - ProductPrice - ${INSURANCE_NAME_VALUE.RENTAL}`,
        );
      }}
    >
      <ProductPriceTile
        validationSchema={validationSchema()}
        initialValues={initialFormState}
        onSubmit={handleSubmit}
        header={"Sjekk pris"}
      >
        <>
          <Form>
            <WrapLgMarginBottom>
              <DittoCoverageCard
                fieldName="coverage"
                product={ProductBackendName.RENTAL}
                coverage={coverage[0]}
                textComponents={productCardTexts}
                prices={coverage[1].prices}
              />
              <BackendErrorAlert
                priceCalculation={priceCalculation.priceCalculationResult}
                addProductToCart={addProductToCart}
              />
            </WrapLgMarginBottom>
            <NavigationButtons isLoading={addProductToCart.isLoading} />
            <InputFailureTracker
              productName={INSURANCE_NAME_VALUE.RENTAL}
              stepId={RENTAL_PRICE_STEP.id}
            />
          </Form>
        </>
      </ProductPriceTile>
    </Sentry.ErrorBoundary>
  );
};
